export * from './src/ecom-v1-abandoned-checkout-abandoned-checkouts.meta.js';
